module.exports = __webpack_public_path__ + "static/img/38.c2ebfb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/38.png
// module id = rhwc
// module chunks = 1